import script from "./ContainerQueryWrapper.vue?vue&type=script&lang=js"
export * from "./ContainerQueryWrapper.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__